import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = `?page=${queryFilter.page}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}&page=${queryFilter.page}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    }
    return axios.get(`/financeiro/bancos${queryUrl}`)
  },
  loadCombo() {
    return axios.get('/financeiro/bancos/lista')
  },
  insertNewBank(data) {
    return axios.post('/financeiro/bancos', data)
  },
  editBank(data) {
    return axios.put(`/financeiro/bancos/${data.id}`, data)
  },
  deleteBank(id) {
    return axios.delete(`/financeiro/bancos/${id}`)
  },
  syncFebraban() {
    return axios.post('/financeiro/bancos/sync-febraban')
  }
}
